<div class="dialog-container">
  <div class="popup-loader-container" *ngIf="loading">
    <div
      class="inner-container uk-flex uk-flex-nowrap uk-flex-center uk-flex-middle"
    >
      <img src="/assets/images/loader.gif" alt="" />
    </div>
  </div>
  <div class="header">
    <p class="white inline-block">
      <b *ngIf="!model && !editing">Add Address</b>
      <b *ngIf="model && !editing">{{ model.address_1 }}</b>
      <b *ngIf="editing">Editing {{ model.address_1 }}</b>
    </p>
    <div class="inline-block float-right">
      <button
        class="uk-button uk-button-nobutton"
        *ngIf="!editing && model"
        (click)="edit()"
      >
        <i class="fas fa-edit"></i>
      </button>
      <button
        class="uk-button uk-button-nobutton"
        *ngIf="(editing && !saving) || addModal"
        type="submit"
        form="contact-address-form"
      >
        <i class="fas fa-save"></i>
      </button>
      <button
        class="uk-button uk-button-nobutton"
        *ngIf="editing"
        (click)="destroy()"
      >
        <i class="fas fa-trash"></i>
      </button>
      <button class="uk-button uk-button-nobutton" (click)="closeDialog()">
        <i class="fas fa-times"></i>
      </button>
    </div>
  </div>
  <div class="content" [ngClass]="{ 'edit-normal-view': model }">
    <div *ngIf="data.breadcrumbs !== undefined" class="generic-breadcrumbs-component">
      <span>
        {{data.breadcrumbs}}
      </span>
      <span>
        <i class="fas fa-chevron-right"></i>
      </span>
      <span>
        Add Address
      </span>
    </div>
    <form [formGroup]="form" (ngSubmit)="submit()" ngNativeValidate id="contact-address-form">
      <div
        class="input-containers margin-top-10"
        [ngClass]="{ editing: editing }"
      >
        <div class="inputs">
          <div class="input-container">
            <input
              type="text"
              formControlName="address_1"
              (keydown)="checkAndSetClass($event)"
              (change)="checkAndSetClass($event)"
              (focus)="checkAndSetClass($event)"
              (input)="checkAndSetClass($event)"
              (blur)="checkAndSetClass($event)"
              [ngClass]="{
                'invalid-input-validation':
                  form.controls.address_1.touched &&
                  form.controls.address_1.invalid
              }"
              [readonly]="!(editing || addModal)"
            />
            <div class="label grey">Address line 1*</div>
            <div *ngIf="form.controls.address_1.touched && form.controls.address_1.invalid" class="error">
              <div *ngIf="form.controls.address_1.errors.required">
                {{ errorManager.ERRORS.address_required }}
              </div>
              <div *ngIf="form.controls.address_1.errors.minlength">
                {{ errorManager.ERRORS.min_2_char_required }}
              </div>
            </div>
          </div>
          <div class="input-container">
            <input
              type="text"
              formControlName="address_2"
              (keydown)="checkAndSetClass($event)"
              (change)="checkAndSetClass($event)"
              (focus)="checkAndSetClass($event)"
              (input)="checkAndSetClass($event)"
              (blur)="checkAndSetClass($event)"
              [readonly]="!(editing || addModal)"
            />
            <div class="label grey">Address line 2</div>
          </div>
          <div class="input-container">
            <input
              type="text"
              formControlName="city"
              (keydown)="checkAndSetClass($event)"
              (change)="checkAndSetClass($event)"
              (focus)="checkAndSetClass($event)"
              (input)="checkAndSetClass($event)"
              (blur)="checkAndSetClass($event)"
              [ngClass]="{
                'invalid-input-validation':
                  form.controls.city.touched &&
                  form.controls.city.invalid
              }"
              [readonly]="!(editing || addModal)"
            />
            <div class="label grey">City*</div>
            <div *ngIf="form.controls.city.touched && form.controls.city.invalid" class="error">
              <div *ngIf="form.controls.city.errors.required">
                {{ errorManager.ERRORS.city_required }}
              </div>
              <div *ngIf="form.controls.city.errors.minlength">
                {{ errorManager.ERRORS.min_2_char_required }}
              </div>
            </div>
          </div>
          <div class="input-container">
            <app-state-select formControlName="state" default></app-state-select>
            <div class="label grey">State*</div>
            <div *ngIf="form.controls.state.touched && form.controls.state.invalid" class="error">
              <div *ngIf="form.controls.state.errors.required">
                {{ errorManager.ERRORS.state_required }}
              </div>
            </div>
          </div>
          <div class="input-container">
            <input
              type="text"
              formControlName="zip"
              (keydown)="checkAndSetClass($event)"
              (change)="checkAndSetClass($event)"
              (focus)="checkAndSetClass($event)"
              (input)="checkAndSetClass($event)"
              (blur)="checkAndSetClass($event)"
              maxlength="5"
              minlength="5"
              [ngClass]="{
                'invalid-input-validation':
                  form.controls.zip.touched &&
                  form.controls.zip.invalid
              }"
              [readonly]="!(editing || addModal)"
            />
            <div class="label grey">Zip code*</div>
            <div *ngIf="form.controls.zip.touched && form.controls.zip.invalid" class="error">
              <div *ngIf="form.controls.zip.errors.pattern">
                {{ errorManager.ERRORS.zip_nine_digit }}
              </div>
            </div>
          </div>
          <div class="input-container uk-text-center">
            <button
              class="uk-button uk-button-primary uk-button-thin savebutton"
              type="submit"
              *ngIf="(editing && !saving) || addModal"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
